import styled from 'styled-components';

export const OptionStyled = styled('option')``;
